import { createClient as t, createConfig as e } from "./hitl-client9.js";
import { createClientConfig as o } from "./hitl-client7.js";
const s = /* @__PURE__ */ t(/* @__PURE__ */ o(/* @__PURE__ */ e({
  baseUrl: "https://hitl.botpress.cloud/"
})));
export {
  s as client
};
